import React from 'react';

export interface ILoaderProps {
    loading: boolean;
    calendarLoadingLabel: string;
}

export const Loader: React.FC<ILoaderProps> = ({ loaderImageUrl, calendarLoadingLabel }) => {
    return (
        <div className="ace-cal-loading" role="presentation">
            <p className="visually-hidden">
                {calendarLoadingLabel}
            </p>
            {
                loaderImageUrl &&
                <img className="ace-cal-loading-image" src={loaderImageUrl} />
            }
        </div>
    )
}